const EVENTS = {
    AV_PROXY_ENABLED: 'av_proxy_enabled',
    AV_CALL_REQUESTED: 'av_call_requested',
    AV_CALL_JOINED: 'av_call_joined',
    AV_CALL_FAILED: 'av_call_failed',
    AV_CALL_RECONNECTING: 'av_call_reconnecting',
    AV_CALL_RECONNECTED: 'av_call_reconnected',
    AV_CALL_DISCONNECTED: 'av_call_disconnected',
    AV_CALL_ENDED: 'av_call_ended',
    AV_CALL_RETRY: 'av_call_retry',
    AV_PUBLISH_MEDIA: 'av_publish_media',
    AV_PUBLISH_MEDIA_INITIALIZATION_SUCCEED: 'av_publish_media_initialization_succeed',
    AV_PUBLISH_CAMERA_INITIALIZATION_SUCCEED: 'av_publish_camera_initialization_succeed',
    AV_PUBLISH_CAMERA_INITIALIZATION_FAILED: 'av_publish_camera_initialization_failed',
    AV_PUBLISH_AUDIO_INITIALIZATION_SUCCEED: 'av_publish_audio_initialization_succeed',
    AV_PUBLISH_AUDIO_INITIALIZATION_FAILED: 'av_publish_audio_initialization_failed',
    AV_PUBLISH_MEDIA_SUCCEED: 'av_publish_media_succeed',
    AV_PUBLISH_MEDIA_FAILED: 'av_publish_media_failed',
    AV_PUBLISH_MEDIA_RETRY: 'av_publish_media_retry',
    AV_PUBLISHED_MEDIA_PROPERTIES_CHANGED: 'av_published_media_properties_changed',
    AV_PUBLISHED_MEDIA_STOPPED: 'av_published_media_stopped',
    AV_PUBLISH_SCREEN: 'av_publish_screen',
    AV_PUBLISH_SCREEN_INITIALIZATION_SUCCEED: 'av_publish_screen_initialization_succeed',
    AV_PUBLISH_SCREEN_SUCCEED: 'av_publish_screen_succeed',
    AV_PUBLISH_SCREEN_FAILED: 'av_publish_screen_failed',
    AV_UNPUBLISH_SCREEN_SUCCEED: 'av_unpublish_screen_succeed',
    AV_PUBLISHED_SCREEN_PROPERTIES_CHANGED: 'av_published_screen_properties_changed',
    AV_PUBLISHED_SCREEN_STOPPED: 'av_published_screen_stopped',
    AV_USER_JOINED: 'av_user_joined',
    AV_PEER_JOINED: 'av_peer_joined',
    AV_PEER_LEFT: 'av_peer_left',
    AV_STREAM_IMAGE_CAPTURE: 'av_stream_image_capture',
    AV_STREAM_IMAGE_CAPTURE_SUCCESS: 'av_stream_image_capture_success',
    AV_STREAM_IMAGE_CAPTURE_FAILED: 'av_stream_image_capture_failed',
    AV_REMOTE_MEDIA_RECEIVED: 'av_remote_media_received',
    AV_REMOTE_MEDIA_LEFT: 'av_remote_media_left',
    AV_REMOTE_MEDIA_PROPERTIES_CHANGED: 'av_remote_media_properties_changed',
    AV_SUBSCRIBE_MEDIA: 'av_subscribe_media',
    AV_SUBSCRIBE_MEDIA_SUCCEED: 'av_subscribe_media_succeed',
    AV_SUBSCRIBE_MEDIA_FAILED: 'av_subscribe_media_failed',
    AV_SUBSCRIBE_MEDIA_VIDEO_DISABLE_WARNING: 'av_subscribe_media_video_disable_warning',
    AV_SUBSCRIBE_MEDIA_VIDEO_DISABLE_WARNING_LIFTED: 'av_subscribe_media_video_disable_warning_lifted',
    AV_SUBSCRIBE_MEDIA_VIDEO_DISABLED: 'av_subscribe_media_video_disabled',
    AV_SUBSCRIBE_MEDIA_VIDEO_ENABLED: 'av_subscribe_media_video_enabled',
    AV_UNSUBSCRIBE_MEDIA_SUCCEED: 'av_unsubscribe_media_succeed',
    AV_REMOTE_SCREEN_RECEIVED: 'av_remote_screen_received',
    AV_REMOTE_SCREEN_LEFT: 'av_remote_screen_left',
    AV_REMOTE_SCREEN_PROPERTIES_CHANGED: 'av_remote_screen_properties_changed',
    AV_SUBSCRIBE_SCREEN: 'av_subscribe_screen',
    AV_SUBSCRIBE_SCREEN_SUCCEED: 'av_subscribe_screen_succeed',
    AV_SUBSCRIBE_SCREEN_FAILED: 'av_subscribe_screen_failed',
    AV_SUBSCRIBE_SCREEN_VIDEO_DISABLE_WARNING: 'av_subscribe_screen_video_disable_warning',
    AV_SUBSCRIBE_SCREEN_VIDEO_DISABLE_WARNING_LIFTED: 'av_subscribe_screen_video_disable_warning_lifted',
    AV_SUBSCRIBE_SCREEN_VIDEO_DISABLED: 'av_subscribe_screen_video_disabled',
    AV_SUBSCRIBE_SCREEN_VIDEO_ENABLED: 'av_subscribe_screen_video_enabled',
    AV_UNSUBSCRIBE_SCREEN_SUCCEED: 'av_unsubscribe_screen_succeed',
    AV_DEBUG_LOCAL_MEDIA_STREAM_CREATED: 'av_debug_local_media_stream_created',
    AV_DEBUG_LOCAL_SCREEN_STREAM_CREATED: 'av_debug_local_screen_stream_created',
    AV_DEBUG_LOCAL_VIDEO_DIMENSIONS_CHANGED: 'av_debug_local_video_dimensions_changed',
    AV_DEBUG_REMOTE_VOLUME_UPDATED: 'av_debug_remote_volume_updated',
    AV_DEBUG_MEDIA_ELEMENT_CREATED: 'av_debug_media_element_created',
    AV_DEBUG_SCREEN_ELEMENT_CREATED: 'av_debug_screen_element_created',
    AV_DEBUG_SEND_MESSAGE_FAILED: 'av_debug_send_message_failed',
    AV_DEBUG_ATTACH_VIDEO: 'av_debug_attach_video',
    AV_DEBUG_DETACH_VIDEO: 'av_debug_detach_video',
    AV_DEBUG_INVALID_JOIN_CALLED: 'av_debug_invalid_join_called',
    AV_MEDIA_DENIED_ERROR: 'av_media_denied_error',
    AV_OT_EXCEPTION: 'av_ot_exception',
    AV_HMS_EXCEPTION: 'av_hms_exception',
};
export default EVENTS;
//# sourceMappingURL=events.js.map